// import dependencies
import React, { Component } from 'react'
import { Form } from 'semantic-ui-react'
import { withAlert } from 'react-alert'
// import components
import EmailFormInputObj from './EmailFormInputObj'
import axios from 'axios'

const baseURL = `https://emailee.herokuapp.com`

class EmailForm extends Component {
  state = {
    fromName: '',
    fromEmail: '',
    to: [{ name: '', email: '' }],
    cc: [{ name: '', email: '' }],
    bcc: [{ name: '', email: '' }],
    subject: '',
    text: '',
    preferred: 'mailgun',
    password: '',
    loading: false
  }
  // fn to update non array/object controlled inputs
  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value })
  }
  // fn to update to / cc / bcc array object controlled inputs
  handleObjChange = (e, i, fields) => {
    // map through state, updating state object with user input and setState
    const newArr = this.state[fields.statename].map((entry, i2) => {
      if (i !== i2) return entry
      return { ...entry, [fields.name]: e.target.value }
    })
    this.setState({ [fields.statename]: newArr })
  }
  // fn to add new field to obj to a state arr
  handleObjAdd = (e, fields) => {
    e.preventDefault() // prevent submit
    // copy state array, add blank object and setState
    const newArr = [...this.state[fields.statename]]
    // only allow 10 input fields
    if (newArr.length < 10) newArr.push({ name: '', email: '' })
    this.setState({ [fields.statename]: newArr })
  }
  // fn to add new field to obj to a state arr
  handleObjRemove = (e, i, fields) => {
    e.preventDefault() // prevent submit
    // map through state, updating state object with user input and setState
    const newArr = this.state[fields.statename].filter((entry, i2) => {
      if (i !== i2) return entry
      return false
    })
    this.setState({
      [fields.statename]: newArr
    })
  }
  handleSubmit = e => {
    e.preventDefault() // prevent submit
    this.setState({ loading: true })
    const data = { ...this.state }

    axios
      .post(`${baseURL}/sendMail`, data)
      .then(res => {
        this.setState({ loading: false })
        const data = res.data
        console.log(res.data)
        // if any errors returned, display to user, otherwise display success message
        if (data.error && data.error.length > 0) {
          data.error.forEach(err => {
            this.props.alert.error(err)
          })
        }
        if (data.success && data.success.length > 0) {
          data.success.forEach(success => {
            this.props.alert.success(success)
          })
        }
      })
      .catch(err => {
        this.setState({ loading: false })
        this.props.alert.error(err.message)
      })
  }

  render() {
    const { fromName, fromEmail, to, cc, bcc, subject, text, password, loading } = this.state
    const preferredOptions = [
      { key: 'm', text: 'Mailgun', value: 'mailgun' },
      { key: 's', text: 'SendGrid', value: 'sendgrid' }
    ]
    // console.log(baseURL)

    return (
      <div className="form-container">
        <h1>Emailee</h1>
        <Form size="mini" onSubmit={this.handleSubmit}>
          <h5>From</h5>
          <Form.Group widths="equal">
            <Form.Input
              type="text"
              placeholder="Name"
              name="fromName"
              value={fromName}
              onChange={this.handleChange}
            />
            <Form.Input
              required
              type="email"
              placeholder="Email"
              name="fromEmail"
              value={fromEmail}
              onChange={this.handleChange}
            />
          </Form.Group>
          {/* create email input fields from state */}
          <EmailFormInputObj
            arr={to}
            statename={'To'}
            handleObjAdd={this.handleObjAdd}
            handleObjChange={this.handleObjChange}
            handleObjRemove={this.handleObjRemove}
          />
          <EmailFormInputObj
            arr={cc}
            statename={'Cc'}
            handleObjAdd={this.handleObjAdd}
            handleObjChange={this.handleObjChange}
            handleObjRemove={this.handleObjRemove}
          />
          <EmailFormInputObj
            arr={bcc}
            statename={'Bcc'}
            handleObjAdd={this.handleObjAdd}
            handleObjChange={this.handleObjChange}
            handleObjRemove={this.handleObjRemove}
          />
          <h5>Subject</h5>
          <Form.Input
            required
            type="text"
            placeholder="Subject"
            name="subject"
            value={subject}
            onChange={this.handleChange}
          />
          <h5>Message Body</h5>
          <Form.TextArea
            required
            placeholder="Message Body"
            name="text"
            value={text}
            onChange={this.handleChange}
          />
          <Form.Group>
            <label>
              <h5>Password</h5>
              <Form.Input
                required
                type="password"
                placeholder="Password"
                name="password"
                value={password}
                onChange={this.handleChange}
              />
            </label>
            <label>
              <h5>Preferred Mail Service</h5>
              <Form.Select
                type="text"
                placeholder="Preferred Mail Service"
                name="preferred"
                options={preferredOptions}
                onChange={this.handleChange}
              />
            </label>
          </Form.Group>
          <Form.Button loading={loading ? true : false}>Submit</Form.Button>
        </Form>
      </div>
    )
  }
}

export default withAlert(EmailForm)



// WEBPACK FOOTER //
// ./src/components/EmailForm.js